import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

const EventIsSplitQueryKey = 'event-is-split'

type UseEventIsSplitParams = {
  plantId: string
  eventId?: string
}

type Options = Omit<UseQueryOptions<boolean, AxiosError>, 'queryKey' | 'queryFn'>

export const useEventIsSplit = ({plantId, eventId}: UseEventIsSplitParams, options?: Options) => {
  const path = `/shifthandover/${plantId}/event-is-split/${eventId}`

  return useQuery<boolean, AxiosError>({
    queryKey: [EventIsSplitQueryKey, eventId, plantId],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<boolean>(path, {signal})
      return response.data
    },
    enabled: !!eventId,
    ...options
  })
}
